import { BankConnectionErrorType } from '../enums/bankConnectionErrorType'

type ShineErrorType = BankConnectionErrorType.ShineConnect | BankConnectionErrorType.ShineMerge

export const shineErrorCommonKeys = {
  cta: 'close',
  title: 'bank_connection.connect_modal.shine.error_title',
} as const

export const shineErrorDescriptions: Record<ShineErrorType, string> = {
  [BankConnectionErrorType.ShineConnect]: 'bank_connection.connect_modal.shine.connect_error_description',
  [BankConnectionErrorType.ShineMerge]: 'bank_connection.connect_modal.shine.merge_error_description',
}
